import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";

import { LayoutComponent as Layout2020Component }  from "./iwaa/2020/layout/layout.component";
import { LayoutComponent as Layout2021Component } from "./iwaa/2021/layout/layout.component";
import { LayoutComponent as Layout2022Component } from "./iwaa/2022/layout/layout.component";
import { LayoutComponent as Layout2023Component } from "./iwaa/2023/layout/layout.component";
import { LayoutComponent as Layout2024Component } from "./iwaa/2024/layout/layout.component";
import { LayoutComponent as Layout2025Component } from "./iwaa/2025/layout/layout.component";
import { LayoutComponent as Layout2026Component } from "./iwaa/2026/layout/layout.component";

const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "/2026/home",
    pathMatch: "full"
  },
  {
    path: "home",
    redirectTo: "/2026/home",
  },
  {
    path: "2020",
    component: Layout2020Component,
    loadChildren: () => import('./iwaa/2020/iwaa.2020.module').then(m => m.Iwaa2020Module)
  },
  {
    path: "2021",
    component: Layout2021Component,
    loadChildren: () => import('./iwaa/2021/iwaa.2021.module').then(m => m.Iwaa2021Module)
  },
  {
    path: "2022",
    component: Layout2022Component,
    loadChildren: () => import('./iwaa/2022/iwaa.2022.module').then(m => m.Iwaa2022Module)
  },
  {
    path: "2023",
    component: Layout2023Component,
    loadChildren: () => import('./iwaa/2023/iwaa.2023.module').then(m => m.Iwaa2023Module)
  },
  {
    path: "2024",
    component: Layout2024Component,
    loadChildren: () => import('./iwaa/2024/iwaa.2024.module').then(m => m.Iwaa2024Module)
  },
  {
    path: "2025",
    component: Layout2025Component,
    loadChildren: () => import('./iwaa/2025/iwaa.2025.module').then(m => m.Iwaa2025Module)
  },
  {
    path: "2026",
    component: Layout2026Component,
    loadChildren: () => import('./iwaa/2026/iwaa.2026.module').then(m => m.Iwaa2026Module)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: "reload",
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
